export default __webpack_public_path__ + "static/media/group-578@3x.cca1c322.png";